var map = {
	"./addrounded.svg": 72254,
	"./arrow_outward.svg": 71432,
	"./authoruser.svg": 78732,
	"./bellheaderl2.svg": 52889,
	"./black_down_arrow.svg": 63127,
	"./black_right_arrow.svg": 3640,
	"./blacksearch.svg": 28176,
	"./blackshare.svg": 9229,
	"./bottomtelegram.svg": 27762,
	"./bredrightarrow.svg": 81413,
	"./calendericon.svg": 68372,
	"./circledownarrow.svg": 45980,
	"./clock.svg": 77062,
	"./close.svg": 39525,
	"./close_small.svg": 31747,
	"./comment.svg": 14249,
	"./disableedit.svg": 55593,
	"./downarrow.svg": 63300,
	"./editicon.svg": 84649,
	"./expand_more.svg": 88214,
	"./expand_more_black.svg": 68041,
	"./facebook_black.svg": 86330,
	"./facebookbottom.svg": 53356,
	"./facebookicon.svg": 71318,
	"./fillbookmarkicon.svg": 29021,
	"./followusgoogle.svg": 19329,
	"./followuswhatsapp.svg": 15675,
	"./gray_right_arrow.svg": 54795,
	"./hamburger_search.svg": 33243,
	"./hamburgersearchicon.svg": 26788,
	"./header_logo.svg": 86765,
	"./headerrednotification.svg": 67251,
	"./info.svg": 19907,
	"./instagram_black.svg": 91499,
	"./instagrambottom.svg": 97965,
	"./instagramcollection.svg": 36299,
	"./linkedin.svg": 49097,
	"./linkedinicon.svg": 77358,
	"./logout.svg": 82033,
	"./longrightarrow.svg": 18123,
	"./mailicon.svg": 8090,
	"./my_account_icon.svg": 51103,
	"./my_account_white.svg": 8587,
	"./newlogo_L1.svg": 78229,
	"./newsletter.svg": 73372,
	"./newsletter_black.svg": 58110,
	"./newsletterimg.svg": 74691,
	"./rightarrow.svg": 64599,
	"./rightarrowblue.svg": 39481,
	"./search.svg": 66759,
	"./search_black.svg": 98177,
	"./search_icon.svg": 38734,
	"./searchfilter.svg": 38237,
	"./share.svg": 43693,
	"./share2.svg": 2402,
	"./shareblueicon.svg": 69513,
	"./shareicon.svg": 82735,
	"./simpledhlogo.svg": 79192,
	"./sliderlefttarrow.svg": 43717,
	"./sliderrightarrow.svg": 90872,
	"./storyshare.svg": 40695,
	"./telegram_black.svg": 43426,
	"./telegramicon.svg": 40658,
	"./twitter_black.svg": 35841,
	"./twitterbottom.svg": 73373,
	"./twittericon.svg": 32003,
	"./user_signin_icon.svg": 38366,
	"./whatsapp_black.svg": 39418,
	"./whatsappicon.svg": 39801,
	"./whiterightarrow.svg": 2284,
	"./whitesearch.svg": 29084,
	"./youtube_black.svg": 38204,
	"./youtubebottom.svg": 20400
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51006;